module.exports = __webpack_public_path__ + "static/media/ReefCafe_Downloadable_Menu.4caf0c19.pdf";